module.exports = __webpack_public_path__ + "img/podcasts_thumbnail-400x300.38f1039e.jpg";